import { Outlet } from 'react-router-dom';

const DealErrorMessageLayout = () => {
  return <Outlet />;
};

export default DealErrorMessageLayout;
